/* RESPONSIBLE TEAM: team-actions */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  namespace: 'api',
});
